/**
 * 通知模块 API
 * - 获取通知列表（分页）
 * - 标记单条/全部已读
 * - 实时推送通过 SSE（见 useSSE hook）
 */
import request from './request'
import type {Notification, NotificationPreferences, PaginationParams, PaginatedResponse} from '@/types'

export const notificationsApi = {
  /** 获取通知列表；未读数由 getUnreadCount 单独查询，避免分页结构和统计字段混在一起。 */
  getList(params?: PaginationParams) {
    return request.get<unknown, PaginatedResponse<Notification>>('/notifications', {params})
  },

  /** 标记单条通知为已读 */
  markAsRead(id: number) {
    return request.patch(`/notifications/${id}/read`)
  },

  /** 标记所有通知为已读 */
  markAllAsRead() {
    return request.patch('/notifications/read-all')
  },

  /**
   * 获取未读数。
   *
   * 这个接口很轻，useSSE 会在创建 EventSource 前先调用它：
   * - 如果 accessToken 过期，axios 拦截器会先用 refreshToken 刷新；
   * - 如果 refresh 也失败，就说明用户确实未登录，不再打开 SSE，避免 401 无限重连。
   */
  getUnreadCount() {
    return request.get<unknown, {count: number}>('/notifications/unread-count')
  },

  getPreferences() {
    return request.get<unknown, NotificationPreferences>('/notifications/preferences')
  },

  updatePreferences(data: Partial<Omit<NotificationPreferences, 'id' | 'userId'>>) {
    return request.patch<unknown, NotificationPreferences>('/notifications/preferences', data)
  }
}
